module.exports = __webpack_public_path__ + "assets/icon-bot.c68bec16.svg";